import { CompanyDetailsEntity, CompanyEntity, CompanyFlagTypeEntity } from '../entities/app-base-app';
import { CompanyFlagHistoryCompositeEntity } from '../extensions/app-extensions';

// TODO: move to company-block

export function isCompanyEntity(item: unknown): item is CompanyEntity {
  return (
    typeof item === 'object' &&
    item !== null &&
    item.hasOwnProperty('uuid') &&
    item.hasOwnProperty('name') &&
    item.hasOwnProperty('org_nr') &&
    item.hasOwnProperty('org_nr_schema')
  );
}

export function isCompanyDetailsEntity(item: unknown): item is CompanyDetailsEntity {
  return (
    typeof item === 'object' &&
    item !== null &&
    item.hasOwnProperty('uuid') &&
    item.hasOwnProperty('company_uuid') &&
    item.hasOwnProperty('org_nr') &&
    item.hasOwnProperty('org_nr_schema') &&
    item.hasOwnProperty('name') &&
    item.hasOwnProperty('establishment_date')
  );
}

export function isCompanyFlagHistoryCompositeEntity(item: unknown): item is CompanyFlagHistoryCompositeEntity {
  return (
    !!item &&
    item.hasOwnProperty('company_flag_history') &&
    item.hasOwnProperty('company') &&
    item.hasOwnProperty('company_flag_type')
  );
}

export function isCompanyFlagHistoryCompositeArray(items: unknown): items is CompanyFlagHistoryCompositeEntity[] {
  return Array.isArray(items) && items.every((item) => isCompanyFlagHistoryCompositeEntity(item));
}

export function isCompanyFlagTypeEntity(item: unknown): item is CompanyFlagTypeEntity {
  return (
    !!item &&
    typeof item === 'object' &&
    item.hasOwnProperty('company_flag_type_key') &&
    item.hasOwnProperty('company_flag_type_description') &&
    item.hasOwnProperty('default_lookback_days') &&
    item.hasOwnProperty('flag_rank') &&
    item.hasOwnProperty('app_feature_uuid') &&
    item.hasOwnProperty('app_role_uuid') &&
    item.hasOwnProperty('app_icon_uuid') &&
    item.hasOwnProperty('default_flag_end_days') &&
    item.hasOwnProperty('company_flag_category_key')
  );
}

export function isCompanyFlagTypeEntityArray(items: unknown): items is CompanyFlagTypeEntity[] {
  return Array.isArray(items) && items.every((item) => isCompanyFlagTypeEntity(item));
}
